export const LLM_PROVIDER_OPTIONS = [
  { value: 'openai', label: 'OpenAI' }
];

// A small curated list; can be expanded later.
export const LLM_MODEL_OPTIONS = [
  { value: 'gpt-5', label: 'gpt-5' },
  { value: 'gpt-5.1', label: 'gpt-5.1' },
  { value: 'gpt-5.2', label: 'gpt-5.2' },
  { value: 'gpt-5-mini', label: 'gpt-5-mini' },
  { value: 'gpt-5-nano', label: 'gpt-5-nano' },
  { value: 'gpt-4o', label: 'gpt-4o' },
  { value: 'gpt-4o-mini', label: 'gpt-4o-mini' },
  { value: 'gpt-4.1', label: 'gpt-4.1' },
  { value: 'gpt-4.1-mini', label: 'gpt-4.1-mini' },
  { value: 'gpt-4.1-nano', label: 'gpt-4.1-nano' }
];

